import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onKeyDownSearchInput = action(
    'onKeyDownSearchInput',
    (evtKeyCode: number, scenarioId: SearchScenarioId) => ({
        evtKeyCode,
        scenarioId,
    })
);

export const onBackspacePressedSearchInput = action(
    'onBackspacePressedSearchInput',
    (scenarioId: SearchScenarioId, cursorPosition: number) => ({ scenarioId, cursorPosition })
);

export const onDownArrowPressedSearchInput = action(
    'onDownArrowPressedSearchInput',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export const onEnterPressedSearchInput = action(
    'onEnterPressedSearchInput',
    (selectedSuggestionIndex: number, scenarioId: SearchScenarioId) => ({
        selectedSuggestionIndex,
        scenarioId,
    })
);

export const onEscapePressedSearchInput = action(
    'onEscapePressedSearchInput',
    (scenarioId: SearchScenarioId, isSuggestionsDropdownVisible: boolean) => ({
        scenarioId,
        isSuggestionsDropdownVisible,
    })
);

export const onLeftArrowPressedSearchInput = action(
    'onLeftArrowPressedSearchInput',
    (cursorPosition: number, scenarioId: SearchScenarioId) => ({ cursorPosition, scenarioId })
);

export const onRightArrowPressedSearchInput = action(
    'onRightArrowPressedSearchInput',
    (scenarioId: SearchScenarioId) => ({ scenarioId })
);

export const onUpArrowPressedSearchInput = action(
    'onUpArrowPressedSearchInput',
    (scenarioId: SearchScenarioId) => ({
        scenarioId,
    })
);

export default onKeyDownSearchInput;
